import api from '@/utils/api';

/**
 * Update a Dealers prices
 * @param {string} id selected company id
 * @param {string} priceId Price id
 * @param {object} priceData - The price data
 * @returns {Promise}
 */
const updateDealerPriceApi = (id, priceId, priceData) =>
  api.patch(`/dealer/${id}/price/${priceId}`, priceData);

export default updateDealerPriceApi;
